import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const FOOTER_LINKS = [
    { label: "About", hash: "#about" },
    { label: "Privacy Policy", to: "/privacy" },
    { label: "Terms of Service", to: "/terms" },
    { label: "Affiliate Disclosure", to: "/affiliate-disclosure" },
    { label: "Contact", to: "/contact" },
];

import { Anchor } from "./Navbar";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-white/10 overflow-hidden">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12">
                    <div className="max-w-sm">
                        <Link to="/" className="flex items-center gap-2" aria-label="LookAura home">
                            <Sparkles className="w-5 h-5 text-amber-500" />
                            <span className="font-serif-display text-xl text-[#FAFAFA]">LookAura</span>
                        </Link>
                        <p className="mt-5 text-sm leading-relaxed text-zinc-500">
                            Your AI Appearance Coach. Personalized style and fashion recommendations, powered by AI analysis of your appearance and preferences.
                        </p>
                    </div>
                    <nav className="grid grid-cols-2 gap-x-16 gap-y-4" aria-label="Footer navigation">
                        {FOOTER_LINKS.map((l) =>
                            l.to ? (
                                <Link key={l.label} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">
                                    {l.label}
                                </Link>
                            ) : (
                                <Anchor key={l.label} hash={l.hash} testId={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-zinc-400 hover:text-amber-400 transition-colors">
                                    {l.label}
                                </Anchor>
                            )
                        )}
                    </nav>
                </div>

                <div className="mt-16 select-none" aria-hidden="true">
                    <p className="font-serif-display text-[13vw] leading-[0.85] tracking-tighter text-white/5 text-center">LOOKAURA</p>
                </div>

                <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-zinc-500" data-testid="footer-copyright">
                        &copy; {new Date().getFullYear()} LookAura. All rights reserved.
                    </p>
                    <p className="text-xs font-mono-accent text-zinc-600">Your AI Appearance Coach</p>
                </div>
            </div>
        </footer>
    );
}
